<div class="card-header">
    <div class="row">
        <div class="col-10">Fødselsdage</div>
        <div class="col-2 text-end"><i class="card-header__icon fa fa-gift"></i></div>
    </div>
</div>
<div class="card-body">
    <ng-container *ngIf="birthDays?.clientsWithBirthday?.length > 0">
        <i>Kunder:</i>
        <div class="table-responsive">
            <table class="clickableTable table table-hover table-striped table-sm">
                <tr *ngFor="let client of birthDays.clientsWithBirthday"
                (click)="onSelectClient(client.kid)">
                    <td>{{client?.navn1}}</td>
                    <td class="text-end">{{client?.birthdayThisYear | date:'dd. MMM'}}</td>
                    <td class="text-end">{{client?.age}} år</td>
                </tr>
            </table>
        </div>
    </ng-container>
    <ng-container *ngIf="birthDays?.spousesWithBirthday?.length > 0">
        <i>Ægtefæller:</i>
        <div class="table-responsive">
            <table class="clickableTable table-hover table table-striped table-sm">
                <tbody>
                    <tr *ngFor="let client of birthDays.spousesWithBirthday"
                    (click)="onSelectClient(client.kid)">
                        <td>{{client?.navn1}}</td>
                        <td class="text-end">{{client?.birthdayThisYear | date:'dd. MMM'}}</td>
                        <td class="text-end">{{client?.age}} år</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
    <ng-container *ngIf="birthDays?.employeesWithBirthday?.length > 0">
        <i>Kollegaer:</i>
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <tbody>
                    <tr *ngFor="let user of birthDays.employeesWithBirthday">
                        <td>{{user?.navn}}</td>
                        <td class="text-end">{{user?.birthdayThisYear | date:'dd. MMM'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
</div>

<div class="card-footer">
    <div class="btn-toolbar float-end">
        <button type="button" (click)="onAll()" class="btn btn-sm btn-primary">Vis alle</button>
    </div>
</div>
